import Controller from "csi/action/Controller";
import locale from "csi/locale";
import declare from "dojo/_base/declare";
import _ from "lodash";

const FetchAdditionalImpactedItemsController = declare(Controller, {

	successMsg: "",
	displayMsg: "",

	postProcessSuccess: function () {
		var nodes = this.m_response.getNodes();
		var impactedItemsRetrived = 0;
		_.forEach(nodes, (node) => {
			if (node.$Type === "ImpactedItem") {
				impactedItemsRetrived++;
			}
		});

		// generate success message
		if (impactedItemsRetrived >= 1) {
			this.displayMsg = `Fetching ImpactedLevels completed. ${impactedItemsRetrived - 1} ImpactedItems retrieved`;
		} else {
			this.displayMsg = "No additional Impacted Items to retrieve";
		}
		this.successMsg = locale.resource(impactedItemsRetrived >= 1 ? this.displayMsg : this.displayMsg, [impactedItemsRetrived]);

		return this.inherited(arguments);
	},

	getSuccess: function (/*String[]?*/params) {
		return this.successMsg;
	},

});

export = FetchAdditionalImpactedItemsController;